import { Body, BodyColor, BodyType, Heading, TypographyColor, TypographyType } from "..";

interface EmptyPlaceholderProps {
    colSpan: number;
    message: string | undefined;
    emptyPlaceholderTitle?: string;
}

export const EmptyPlaceholder = ({ colSpan, message, emptyPlaceholderTitle }: EmptyPlaceholderProps) => {
    return (
        <tr>
            <td colSpan={colSpan} className="text-center">
                <div className="d-flex flex-column justify-content-center align-items-center h-100 m-0 p-0">
                    {emptyPlaceholderTitle &&
                        <Heading
                            title={emptyPlaceholderTitle}
                            type={TypographyType.h5}
                            colour={TypographyColor.primary}
                            classname="m-0 p-0"
                        />}
                    <Body
                        type={BodyType.p3}
                        color={BodyColor.secondary}
                        classname="d-block padding-top-bottom-2"
                    >
                        {message}
                    </Body>
                </div>
            </td>
        </tr>
    );
};
